import React, { Component } from "react";
import Collapsible from "../collapsible";

export default class FAQList extends Component {
  constructor() {
    super();
    this.state = {
      index: -1,
    };
    this.toggle = this.toggle.bind(this);
  }

  toggle(index) {
    if (index === this.state.index) index = -1;
    this.setState({ index });
  }

  render() {
    return this.list.map((question, index) => (
      <Collapsible
        toggle={this.toggle}
        title={question.q}
        index={index}
        key={index}
        show={this.state.index === index}
        headerClassName="faqHeader"
        contentClassName="faqContent"
        headerColor="color-blue"
      >
        {question.a}
      </Collapsible>
    ));
  }

  list = [
    {
      q: "What is XXOO 10?",
      a: (
        <p>
          XXOO 10 is a take on the traditional{" "}
          <a
            href="https://play.google.com/store/apps/details?id=com.doublethefun.ufit"
            target="_blank"
            rel="noopener noreferrer"
          >
            Tic Tac Toe
          </a>{" "}
          and connect 4 games, but can be played by up to 10 players on a 10 by
          10 grid. The different variations also mean you can win a game by
          making 3 in a row, 4 in a row, ...etc. up to 10 in a row. It has over
          300+ fun practice games where you can earn credits that can be used to
          play games with your friends and other people around the world.
        </p>
      ),
    },
    {
      q: "Why do I need to Sign Up?",
      a: (
        <p>
          Signing up is free and it allows you to access all features within the
          app.
        </p>
      ),
    },
    {
      q: "How do I win?",
      a: (
        <p>
          You need to place 3, 4, 5, ...etc. of your game piece in a horizontal,
          vertical, or diagonal row In order to win a game. There'll be an
          message pop up when starting a game that indicates the number of game
          pieces you'll need in a row in order to win.
        </p>
      ),
    },
    {
      q: "How to create a game?",
      a: (
        <p>
          Switch to the Games tab and click the Create Game button. Then
          customize your game and click the Save button at the top right corner
          of the screen. Now, wait until you have enough players to join your
          game before you can start.
        </p>
      ),
    },
    {
      q: "How to join a game?",
      a: (
        <p>
          Switch to the Games tab and click on one of the games listed. Then
          click the Join button. Now, wait until you're approved by the host
          before the game can start.
        </p>
      ),
    },
    {
      q: "How to start a game?",
      a: (
        <p>
          For Practice Games, once you click on a game and are in the game
          screen, you need to spin the wheel to see who goes first. If you go
          first, then just start by clicking on an empty space. For Online
          Games, the host/creator of the game starts by clicking an empty space
          on the board.
        </p>
      ),
    },
    {
      q: "Can I play with my friends?",
      a: (
        <p>
          Yes, you can play with up to 9 of your friends at the same time. You
          can create private games and invite only your friends to join. Just
          ask your friends to download the app and sign in.
        </p>
      ),
    },
    {
      q: "How to invite friends?",
      a: (
        <p>
          When creating a game, click the Invite Friends icon. This will add
          your friend to the game without needing them to join and your
          approval.
        </p>
      ),
    },
    {
      q: "How to earn credits?",
      a: (
        <p>
          Each Practice Game you win will earn you two credit. However, losing
          or tie will cost you a credit. Therefore, resulting in you earning one
          credit if you win.
        </p>
      ),
    },
    {
      q: "How to tell if your friends is online?",
      a: (
        <p>
          Click the Friend tab. If your friends is online, then an indicatin
          will be shown next to their name.
        </p>
      ),
    },
  ];
}
